





























import Vue from 'vue';
import { defineComponent, computed, reactive } from '@vue/composition-api';
import { generateRandomId } from '../helpers';

export default defineComponent({
    props: {
        name: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            dafault: ''
        },
        error: {
            type: Object,
            default: null
        },
        checked: {
            type: [Boolean, Array],
            required: true
        }
    },

    model: { prop: 'checked', event: 'input' },

    setup(props, context) {
        if (!props.value && !props.name) {
            console.warn('Missing required prop: "name" or "value" should be provided');
        }

        const id = generateRandomId(props.name);

        const isChecked = computed(() => {
            if (Array.isArray(props.checked)) {
                return props.checked.includes(props.value || props.name);
            }
            else {
                return props.checked;
            }
        })

        const onChange = (evt: Event) => {
            if (evt.target instanceof HTMLInputElement) {
                let value = props.value || props.name;

                if (Array.isArray(props.checked)) {
                    // For v-model to work we need to emit a whole new array because,
                    // unfortunately, the behavior of mutating the array is a trick done
                    // by vuejs *only* when v-model is applied on a native HTML input.
                    let input: string[] = [].concat(<any>props.checked);
                    if (input.includes(value)) {
                        if (!evt.target.checked) {
                            input.splice(input.indexOf(value), 1);
                        }
                    }
                    else {
                        if (evt.target.checked) {
                            input.push(value);
                        }
                    }
                    context.emit('input', input);
                }
                else {
                    context.emit('input', evt.target.checked, value);
                }
            }
        }

        return {
            id,
            isChecked,
            onChange
        }
    }
})
